import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import UnauthorizedPage from "../pages/UnauthorizedPage";
import { usePermissions } from "../hooks/usePermissions";

const ProtectedRoute = ({ requiredPermissions = [], children }) => {
  const location = useLocation();
  const { userInfo, hasAllPermissions } = usePermissions();

  if (!userInfo) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermissions.length > 0) {
    if (!hasAllPermissions(requiredPermissions)) {
      return <UnauthorizedPage />;
    }
  }

  return children;
};

export default ProtectedRoute;
